import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Benefits } from "./components/Benefits";
import { Portfolio } from "./components/Portfolio";
import { Socials } from "./components/Socials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#eeede9] text-[#111]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Benefits />
        <Portfolio />
        <Socials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
